import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../axiosConfig';

export const fetchMerchantNotifications = createAsyncThunk(
  'notifications/fetchMerchant',
  async () => {
    const res = await axios.get('merchant/notifications', { withCredentials: true });
    return res.data.notifications || [];
  }
);

export const markMerchantNotificationRead = createAsyncThunk(
  'notifications/markRead',
  async (notificationId) => {
    await axios.put(`merchant/notifications/${notificationId}/read`, {}, { withCredentials: true });
    return notificationId;
  }
);

// Single bulk call instead of N per-row PUTs. The previous implementation
// looped client-side and fired a request per unread item.
export const markAllNotificationsRead = createAsyncThunk(
  'notifications/markAllRead',
  async () => {
    await axios.put('merchant/notifications/mark-all-read', {}, { withCredentials: true });
  }
);

export const deleteNotification = createAsyncThunk(
  'notifications/delete',
  async (notificationId) => {
    await axios.delete(`merchant/notifications/${notificationId}`, { withCredentials: true });
    return notificationId;
  }
);

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: { items: [], status: 'idle', error: null },
  reducers: {},
  extraReducers: (b) => {
    b.addCase(fetchMerchantNotifications.pending, (s) => { s.status = 'loading'; })
     .addCase(fetchMerchantNotifications.fulfilled, (s, a) => { s.status = 'succeeded'; s.items = a.payload; s.error = null; })
     .addCase(fetchMerchantNotifications.rejected, (s, a) => { s.status = 'failed'; s.error = a.error.message; })
     .addCase(markMerchantNotificationRead.fulfilled, (s, a) => {
        const idx = s.items.findIndex(n => n.id === a.payload);
        if (idx !== -1) s.items[idx].isRead = true;
     })
     .addCase(markAllNotificationsRead.fulfilled, (s) => {
        s.items.forEach(n => { n.isRead = true; });
     })
     .addCase(deleteNotification.fulfilled, (s, a) => {
        s.items = s.items.filter(n => n.id !== a.payload);
     });
  }
});

export default notificationsSlice.reducer;
